import React, { useMemo } from 'react';
import { plural } from 'utils/plural';
import { Rating } from 'fronton-react';
import { memo } from 'common/hocs/memo';
import { css } from 'linaria';
import { DATA_QA_PRODUCT_REVIEWS } from './constants';
import { productReviewsRating, productReviewsRatingWrapper } from './styles';

type ProductReviewsProps = {
  rating: number;
  reviewsNumber: number;
  href: string;
  onClick: () => void;
};

export const ProductReviews = memo<ProductReviewsProps>(function ProductReviews({
  rating,
  reviewsNumber,
  href,
  onClick,
}) {
  const caption = useMemo(() => {
    const wordForm = plural(reviewsNumber, 'отзыв', 'отзыва', 'отзывов');
    return (
      <div>
        <span className={reviewsNumberWrap}>{reviewsNumber}</span>{' '}
        <span className={reviewsCaptionWrap}>{wordForm}</span>
      </div>
    );
  }, [reviewsNumber]);

  return (
    <div className={productReviewsRatingWrapper}>
      <Rating
        className={productReviewsRating}
        hasLink
        value={rating}
        size={'s'}
        data-qa={DATA_QA_PRODUCT_REVIEWS}
        onClick={onClick}
        href={href}
      >
        {caption}
      </Rating>
    </div>
  );
});

const reviewsNumberWrap = css`
  @media (--to-largeDesktop) {
    &::before {
      content: '(';
    }

    &::after {
      content: ')';
    }
  }
`;
const reviewsCaptionWrap = css`
  display: inline;

  @media (--to-largeDesktop) {
    display: none;
  }
`;
